"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.configState = void 0;
var React = __importStar(require("react"));
var App_1 = require("../../App");
var enums_1 = require("./enums");
var track_1 = __importDefault(require("./track"));
exports.configState = function (state) {
    switch (state.challenge) {
        case enums_1.RiskActions.PaymentCardNotVerified:
            return {
                eventPrefix: 'second_card',
                table: 'card_challenge',
                workflow: state.workflow
            };
        case enums_1.RiskActions.ReenterPaymentCard:
            return {
                eventPrefix: 'reentry',
                table: 'card_reentry',
                workflow: state.workflow
            };
        case enums_1.RiskActions.VerificationRequired:
        case enums_1.RiskActions.PhoneEmailVerify:
            return {
                eventPrefix: 'action_verify',
                table: 'web_2fa_tracking',
                workflow: state.workflow
            };
        case enums_1.RiskActions.RequiresThreeDSecure:
            return {
                eventPrefix: 'three_d_secure',
                table: 'web_three_d_secure',
                workflow: state.workflow
            };
    }
    return { eventPrefix: 'default', table: 'default', workflow: 'default' };
};
var useTracking = function (orderCartIdInit) {
    var state = React.useContext(App_1.RiskContext).state;
    var trackingState = exports.configState(state);
    var trackLoad = function (orderCartId) {
        track_1["default"](trackingState.table, {
            workflow: trackingState.workflow,
            order_cart_id: orderCartId || orderCartIdInit,
            type: trackingState.eventPrefix + "_load"
        });
    };
    var trackContactSupport = function (orderCartId) {
        return track_1["default"](trackingState.table, {
            workflow: trackingState.workflow,
            order_cart_id: orderCartId || orderCartIdInit,
            type: 'contact_support'
        });
    };
    var trackClose = function () {
        return track_1["default"](trackingState.table, {
            workflow: trackingState.workflow,
            type: trackingState.eventPrefix + "_close"
        });
    };
    var trackClick = function (orderCartId) {
        return track_1["default"](trackingState.table, {
            workflow: trackingState.workflow,
            order_cart_id: orderCartId || orderCartIdInit,
            type: trackingState.eventPrefix + "_verify_click"
        });
    };
    var trackSuccess = function (orderCartId) {
        return track_1["default"](trackingState.table, {
            workflow: trackingState.workflow,
            order_cart_id: orderCartId || orderCartIdInit,
            type: trackingState.eventPrefix + "_success"
        });
    };
    var trackFailure = function (_a) {
        var orderCartId = _a.orderCartId, reason = _a.reason, message = _a.message;
        return track_1["default"](trackingState.table, {
            reason: reason,
            message: message,
            workflow: trackingState.workflow,
            order_cart_id: orderCartId || orderCartIdInit,
            type: trackingState.eventPrefix + "_failure"
        });
    };
    return {
        trackLoad: trackLoad,
        trackContactSupport: trackContactSupport,
        trackClose: trackClose,
        trackClick: trackClick,
        trackSuccess: trackSuccess,
        trackFailure: trackFailure
    };
};
exports["default"] = useTracking;
